"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExclusionZoneTypeEnum = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/no-extraneous-dependencies */
var react_1 = tslib_1.__importDefault(require("react"));
var axios_1 = tslib_1.__importDefault(require("axios"));
var react_query_1 = require("react-query");
var useDebounce_1 = tslib_1.__importDefault(require("react-use/lib/useDebounce"));
var ExclusionZoneTypeEnum;
(function (ExclusionZoneTypeEnum) {
    ExclusionZoneTypeEnum["Airport"] = "airport";
    ExclusionZoneTypeEnum["Redirect"] = "redirect";
    ExclusionZoneTypeEnum["Lot"] = "lot";
    ExclusionZoneTypeEnum["HandoverOutpost"] = "handover_outpost";
})(ExclusionZoneTypeEnum = exports.ExclusionZoneTypeEnum || (exports.ExclusionZoneTypeEnum = {}));
var getPlaces = function (searchQuery, requestConfig) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, data;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, axios_1.default.get("v1/places?search=".concat(searchQuery), requestConfig)];
            case 1:
                _a = (_b.sent()).data.data, data = _a === void 0 ? [] : _a;
                return [2 /*return*/, data];
        }
    });
}); };
var usePlacesSearch = function (searchQuery, requestConfig, queryOptions) {
    var _a = react_1.default.useState(''), search = _a[0], setSearch = _a[1];
    (0, useDebounce_1.default)(function () { return setSearch(searchQuery); }, 600, [searchQuery]);
    return (0, react_query_1.useQuery)(tslib_1.__assign({ queryKey: ['place', search], queryFn: function () { return getPlaces(search, requestConfig); }, enabled: Boolean(search) }, queryOptions));
};
exports.default = usePlacesSearch;
//# sourceMappingURL=use-places-search.js.map